import type { PropsWithChildren } from "react"
import React, { createContext, useContext, useEffect, useState } from "react"

import { isInAppMode } from "~utils/native-auth-bridge"

interface IInAppBrowserContext {
    isInAppBrowser: boolean
}

const InAppBrowserContext = createContext<IInAppBrowserContext>({
    isInAppBrowser: false,
})

export function InAppBrowserProvider({
    children,
}: Readonly<PropsWithChildren>) {
    const value = useInAppBrowserValues()

    return (
        <InAppBrowserContext.Provider value={value}>
            {children}
        </InAppBrowserContext.Provider>
    )
}

export function useInAppBrowserContext(): IInAppBrowserContext {
    return useContext(InAppBrowserContext)
}

function useInAppBrowserValues(): IInAppBrowserContext {
    // Start false so the first client render matches the Gatsby-prerendered
    // HTML (the server can't see the URL or sessionStorage), then detect the
    // flag after mount to avoid a hydration mismatch.
    const [isInAppBrowser, setIsInAppBrowser] = useState(false)

    useEffect(() => {
        // isInAppMode owns the `in_app` param semantics, the sessionStorage
        // persistence, and the `?in_app=false` reset. It also switches auth
        // to the native token bridge (see ~utils/native-auth-bridge).
        setIsInAppBrowser(isInAppMode())
    }, [])

    return {
        isInAppBrowser,
    }
}
